import { Flow, flowMeta, flowOrder } from '../content/site';
import './FlowSwitch.css';

type Props = {
  value: Flow;
  onChange: (flow: Flow) => void;
  label: string;
  tone?: 'light' | 'ink';
};

/** Segmented control for switching between the practice and will bank journeys. */
export function FlowSwitch({ value, onChange, label, tone = 'light' }: Props) {
  return (
    <div className={`flow-switch flow-switch--${tone}`}>
      <span className="flow-switch__label">{label}</span>
      <div className="flow-switch__track" role="tablist" aria-label={label}>
        {flowOrder.map((flow) => {
          const selected = value === flow;
          return (
            <button
              key={flow}
              type="button"
              role="tab"
              id={`flow-tab-${flowMeta[flow].slug}`}
              aria-selected={selected}
              aria-controls={`flow-panel-${flowMeta[flow].slug}`}
              className={`flow-switch__option ${selected ? 'is-selected' : ''}`}
              onClick={() => onChange(flow)}
            >
              {flowMeta[flow].short}
            </button>
          );
        })}
      </div>
    </div>
  );
}
